/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'page.workbench.profile.menu.base': '基础信息',
  'page.workbench.profile.menu.security': '安全设置',
  'page.workbench.profile.menu.bind': '账号绑定',
  'page.workbench.profile.base.avatar_title': '头像',
  'page.workbench.profile.base.avatar_change_title': '更换头像',
  'page.workbench.profile.base.form.account_id': '账户ID',
  'page.workbench.profile.base.form.username': '用户名',
  'page.workbench.profile.base.form.email': '邮箱',
  'page.workbench.profile.base.form.phone': '手机号',
  'page.workbench.profile.base.form.full_name': '姓名',
  'page.workbench.profile.base.form.full_name.rule.0': '请输入您的姓名',
  'page.workbench.profile.base.form.nick_name': '昵称',
  'page.workbench.profile.base.form.update_button': '更新',
  'page.workbench.profile.common.form.password': '密码',
  'page.workbench.profile.common.form.password.placeholder': '请输入密码',
  'page.workbench.profile.common.form.password.rule.0': '请输入密码',

  'page.workbench.profile.common.form.phone': '手机号',
  'page.workbench.profile.common.form.phone.placeholder': '请输入手机号',
  'page.workbench.profile.common.form.phone.rule.0': '手机号未填写',
  'page.workbench.profile.common.form.phone.rule.1': '手机号不合法',

  'page.workbench.profile.common.form.code': '验证码',
  'page.workbench.profile.common.form.code.placeholder': '请输入验证码',
  'page.workbench.profile.common.form.code.rule.0': '请输入验证码',
  'page.workbench.profile.please_send_code.message': '请发送验证码',
  'page.workbench.profile.bind.totp.form.update_email': '修改邮箱',
  'page.workbench.profile.modify_email.form.email': '邮箱',
  'page.workbench.profile.modify_email.form.email.placeholder': '请输入邮箱',
  'page.workbench.profile.modify_email.form.email.rule.0': '请输入邮箱',
  'page.workbench.profile.modify_email.form.email.rule.1': '邮箱格式不正确',
  'page.workbench.profile.modify_password.form': '修改密码',
  'page.workbench.profile.modify_password.success': '修改成功，请重新登录',

  'page.workbench.profile.modify_password.form.old_password': '旧密码',
  'page.workbench.profile.modify_password.form.old_password.placeholder': '请输入旧密码',
  'page.workbench.profile.modify_password.form.old_password.rule.0': '请输入旧密码',

  'page.workbench.profile.modify_password.form.new_password': '新密码',
  'page.workbench.profile.modify_password.form.new_password.placeholder': '请输入新密码',
  'page.workbench.profile.modify_password.form.new_password.rule.0': '请输入新密码',
  'page.workbench.profile.modify_password.form.verify-code': '验证码',
  'page.workbench.profile.modify_password.form.verify-code-type.label': '验证方式',
  'page.workbench.profile.modify_password.form.verify-code-type.rule.0': '请选择验证方式',
  'page.workbench.profile.modify_password.form.phone.label': '短信',
  'page.workbench.profile.modify_password.form.mail.label': '邮件',
  'page.workbench.profile.modify_password.form.phone': '手机号',
  'page.workbench.profile.modify_password.form.mail': '邮箱',
  'page.workbench.profile.modify_email.form': '修改手机号',

  'page.workbench.profile.unbind': '解绑',
  'page.workbench.profile.unbind_confirm_title': '系统通知',
  'page.workbench.profile.unbind_confirm_content': '确定要解除与该身份提供商绑定吗？',
  'page.workbench.profile.unbind_success': '解绑成功',
  'page.workbench.profile.bind': '绑定',
  'page.account.bind.success': '绑定成功',
  'page.account.bind.totp': '绑定动态口令',
  'page.account.bind.totp.form.verify': '身份验证',
  'page.account.bind.totp.form.verify.placeholder': '输入密码确认身份',
  'page.account.bind.totp.form.bind': '绑定动态口令',
  'page.account.bind.totp.form.bind.placeholder': '使用移动端认证器绑定口令',
  'page.account.bind.totp.form.bind.alert': '请使用市面常见认证器 APP，扫描下方二维码，完成绑定。',
  'page.account.bind.totp.form.bind.paragraph':
    '扫码绑定后，请您输入移动端 APP 中的六位动态口令，完成本次绑定。',
  'page.account.bind.totp.form.update_email': '修改邮箱',
  'page.account.modify_email.form.email': '邮箱',
  'page.account.modify_email.form.email.placeholder': '请输入邮箱',
  'page.account.modify_email.form.email.rule.0': '请输入邮箱',
  'page.account.modify_email.form.email.rule.1': '邮箱格式不正确',
  'page.account.modify_password.form': '修改密码',
  'page.account.modify_password.success': '修改成功，请重新登录',
  'page.account.modify_password_form.new_password': '新密码',
  'page.account.modify_password_form.new_password.placeholder': '请输入新密码',
  'page.account.modify_password_form.new_password.rule.0': '请输入新密码',
  'page.account.modify_password_form.verify-code': '验证码',
  'page.account.modify_password_form.verify-code.placeholder': '请输入验证码',
  'page.account.modify_password_form.verify-code.required': '验证码未填写',
  'page.account.modify_password_form.verify-code.invalid': '验证码无效或已过期',
  'page.account.modify_password_form.verify-code.mistake': '验证码错误或已失效',
  'page.account.modify_password_form.get-opt-code': '获取验证码',
  'page.account.modify_password_form.get-opt-code.success': '获取验证码成功',
  'page.account.modify_password_form.captcha-second-text': '秒后重新获取',
  'page.account.modify_password_form.verify-code-type.label': '验证方式',
  'page.account.modify_password_form.verify-code-type.rule.0': '请选择验证方式',
  'page.account.modify_password_form.phone.label': '短信',
  'page.account.modify_password_form.mail.label': '邮件',
  'page.account.modify_password_form.phone': '手机号',
  'page.account.modify_password_form.mail': '邮箱',
  'page.account.modify_email.form': '修改手机号',
};
